import {Client, Message} from 'paho-mqtt';

class PahoMqttClient {
    constructor() {
        this.client = null;
    }

    connect(brokerUrl, clientId, options = {}) {
        // Create a new MQTT client instance
        this.client = new Client(brokerUrl, clientId);

        // Set connection handlers
        this.client.onConnectionLost = (response) => {
            console.error('MQTT connection lost:', response.errorMessage);
        };

        /*this.client.onMessageArrived = (message) => {
            console.log(`Message received on topic ${message.destinationName}:`, message.payloadString);
        };*/

        // Connection options
        const connectionOptions = {
            onSuccess: () => {
                console.log('Connected to MQTT broker');
                if (options.onSuccess) {
                    options.onSuccess(); // Execute the provided success callback
                }
            },
            onFailure: (err) => {
                console.error('MQTT connection failed:', err.errorMessage);
                if (options.onFailure) {
                    options.onFailure(err);
                }
            },
            useSSL: brokerUrl.startsWith('wss://'),
        };

        // Add username and password only if provided
        if (options.username) connectionOptions.userName = options.username;
        if (options.password) connectionOptions.password = options.password;

        // Connect to the broker
        this.client.connect(connectionOptions);
    }

    subscribe(topic) {
        if (this.client && this.client.isConnected()) {
            this.client.subscribe(topic);
        } else {
            console.error('MQTT client is not connected');
        }
    }

    unsubscribe(topic) {
        if (this.client && this.client.isConnected()) {
            this.client.unsubscribe(topic);
            console.log(`Unsubscribed to topic: ${topic}`);
        } else {
            console.error('MQTT client is not connected');
        }
    }

    publish(topic, message) {
        if (this.client && this.client.isConnected()) {
            const mqttMessage = new Message(message);
            mqttMessage.destinationName = topic;
            this.client.send(mqttMessage);
            console.log(`Published message: ${message} to topic: ${topic}`);
        } else {
            console.error('MQTT client is not connected');
        }
    }

    disconnect() {
        if (this.client) {
            this.client.disconnect();
            console.log('Disconnected from MQTT broker');
        }
    }
}

export default new PahoMqttClient();
